import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  automatedResponses: {
    id: 'app.containers.Chatbot.AutomatedResponse.automatedResponses',
    defaultMessage: `Automated Responses`,
  },
  noAutomatedResponses: {
    id: 'app.containers.Chatbot.AutomatedResponse.noAutomatedResponses',
    defaultMessage: `No automated responses! Please import or add new.`,
  },
  editMessageTemplate: {
    id: 'app.containers.Chatbot.AutomatedResponse.editMessageTemplate',
    defaultMessage: `Edit message template`,
  },
  chooseModel: {
    id: 'app.containers.Chatbot.Automatedreponses.chooseModel',
    defaultMessage: 'Choose a model to view the automated responses.',
  },
});
